// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineCheckboxGroup_root__Rx1bq","label":"MantineCheckboxGroup_label__N5gVB"};